var map = {
	"./andrea.jpg": "7f45",
	"./andrea_.jpg": "4e1e",
	"./chiara.jpg": "7fdb",
	"./chiara_.jpg": "180e",
	"./da39a3ee5e6b4b0d3255bfef95601890afd80709.jpg": "a9d9",
	"./da39a3ee5e6b4b0d3255bfef95601890afd80709_.jpg": "e73f",
	"./daniele.jpg": "4f2f",
	"./daniele_.jpg": "7f1a",
	"./giovanni.jpg": "a41e",
	"./giovanni_.jpg": "53f7",
	"./letizia.jpg": "dfca",
	"./letizia_.jpg": "784d",
	"./marialuisa.jpg": "6649",
	"./marialuisa_.jpg": "cd3f",
	"./maurizio.jpg": "8003",
	"./maurizio_.jpg": "efe7",
	"./natalia.jpg": "a112",
	"./natalia_.jpg": "f3b9",
	"./terrj.jpg": "8421",
	"./terrj_.jpg": "c588"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b270";